import {Component, ElementRef, OnInit, OnDestroy, ViewChild, TemplateRef, Input} from '@angular/core';
import {ChangesSubject, DataChangesObserver, Logger, TitleInfo, TitleService} from '@common-lib';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {ToasterService} from 'angular2-toaster';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {SettingsService} from '../../pages-services/';
import {ConfirmPopupComponent} from '../../components';
import {LocalStorageService} from '@common-lib';
import {TranslationsService, ProductsService} from '../../pages-services';
import {LOCALE_CONFIG} from '@common-lib';
import { timer } from 'rxjs/observable/timer';
import { areIterablesEqual } from '@angular/core/src/change_detection/change_detection_util';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs'
import {environment} from "../../../environments/environment";

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit, OnDestroy {
    @Input() selectedLocale = [];
    @Input() productsToPublish: any[] = [];

    requestStatus$: Observable<number>;
    timeInterval : number = 20000;
    sub: Subscription;

    publishInProcess = '';
    haveChanges = false;
    changesCount = 0;
    publishVersion = '';
    publishVersionsList: Array<{ version: string, publishedAt: string }> = [];
    isPublishing = true;
    imagePacks = [];
    selectedImagePack = null;
    isPackageUploading = false;
    locales = [];
    products = [];
    choices = [
        {name: 'Muiltichoice', id: true},
        {name: 'Singlechoice', id: false}
    ];
    settings = {
        main: {
            icon: '',
            name: '',
            markets: []
        },
        email: {} as { isSmtp: boolean, emailFrom: string, smtp: { host: string, port: number, isSecure: boolean, auth: { user: string, password: string } } },
        theme: {} as { foreground: string, background: string, font: string },
        social: [] as Array<{ name: string, url: string, appId?: string }>,
        categories: [],
        all_subcategories: [],
        all_locates: [],
        all_drops: [],
        loading: true,
    };
    changesSubject: ChangesSubject;
    // isLoading = !Object.keys(this.settings).length;
    selectedCategories = {};
    selectedSubcategories = {};

    publishSettingsModalRef: BsModalRef;

    @ViewChild(ConfirmPopupComponent)
    confirmPopup: ConfirmPopupComponent;

    @ViewChild('publishSettingsFormTemplate')
    publishSettingsFormTemplate: TemplateRef<any>;

    constructor(private title: TitleService,
                private logger: Logger,
                private route: ActivatedRoute,
                private router: Router,
                private settingsService: SettingsService,
                private toasterService: ToasterService,
                private translateService: TranslateService,
                private translationService: TranslateService,
                private container: ElementRef,
                private translationsService: TranslationsService,
                private productsService: ProductsService,
                private datachanges: DataChangesObserver,
                private storage: LocalStorageService,
                private modalService: BsModalService) {
    }

    init() {
      this.isPublishing = JSON.parse(this.storage.getItem('isPublishing', 'false'));
      this.logger.debug('in dashboard: ', this.route.snapshot.data);
      this.title.setTitle(this.route.snapshot.data.title ? this.route.snapshot.data.title : '');
      this.getSettingsData();
      this.settingsService.loadPublishVersionsList().subscribe((data) => {
        this.publishVersionsList = data.versions;
        this.publishInProcess = data.publishInProcess;
        // this.publishVersion = data.active;
      });
      this.startInterval();
    }

    ngOnInit() {
      console.log('ngOnInit');
      this.init();
    }

  ngOnDestroy() {
      if (this.sub) {
        this.sub.unsubscribe();
      }
    }

    startInterval() {
      this.requestStatus$ = timer(0, this.timeInterval).pipe();
      this.sub = this.requestStatus$.subscribe((data) => {
        this.checkStatus();
      });
    }

    saveSettingsData() {
        this.settingsService.saveSettings(this.settings).subscribe(async (settings) => {
            this.settings = this.createChangesObservation(settings);
            let successMessage = await this.translateService.get('webpanel.save.settings.success_message').toPromise();
            this.toasterService.pop('success', '', successMessage);
        });
    }

    getSettingsData() {
        this.settingsService.getSettings().subscribe(settings => {
            if (settings.img_packages.data) {
                settings.img_packages.data.sort((a, b) => a.createdAt.localeCompare(b.createdAt));
                settings.img_packages.data = settings.img_packages.data.map((r) => {
                    r.isActive = false;
                    return r;
                });
                settings.img_packages.data.unshift({
                    id: -1,
                    createdAt: '',
                    updatedAt: null,
                    isActive: true,
                    size: 'New package'
                });
                settings.img_packages.activeEntity = -1;
            }
            this.logger.debug(settings.img_packages);
            this.settings = this.createChangesObservation(settings);
        });
        this.translationsService.getLocalizations().subscribe((data) => {
          this.locales = data.reduce((acc, cur, i) => {
              cur.locales.forEach((locale) => {
                  acc = [...acc, {
                      localeName: locale,
                      languageCode: cur.language,
                      languageTitle: cur.title,
                  }];
              });
              return acc;
          }, []);
          this.locales
            .sort((a, b) => a.localeName.localeCompare(b.localeName))
            .unshift({
              localeName: LOCALE_CONFIG.DEFAULT_LOCALE,
              languageCode: "Global",
              languageTitle: "Global",
            });
        });


        this.productsService.getAll().subscribe(({products}) => {
          this.products = products;
        });

  }

    isLoading() {
        return this.settings.loading;
    }

    toggleMarketCheckbox(language) {
        const index = this.settings.main.markets.indexOf(language);
        if (index !== -1) {
            this.settings.main.markets.splice(index, 1);
        } else {
            this.settings.main.markets.push(language);
        }
    }

    isCountryChecked(language) {
        return this.settings.main.markets.indexOf(language) !== -1;
    }

    cancelChanges() {
        if (this.changesSubject) {
            this.changesSubject.cancelChanges();
        }
    }

    private createChangesObservation(settings) {
        this.changesCount = 0;
        this.haveChanges = false;
        let subject = this.datachanges.observe(settings);
        this.changesSubject = subject;
        subject.onChanges.subscribe((event) => {
            this.changesCount = event.subject.changesCount;
            this.haveChanges = this.changesCount > 0;
        });
        return subject.getProxy();
    }

    async publish() {
        this.confirmPopup.show();
        this.storage.putItem('isPublishing', 'true');
        this.isPublishing = true;
    }

    contains(arr, obj: {field: string, value: string}): boolean {
        return arr.find((r) => r[obj.field] === obj.value) !== undefined;
    }

    indexOf(arr, obj: {field: string, value: string}): number {
        let index = -1;
        arr.forEach((r, i) => {
            if(this.contains(arr, obj)){
                index = i;
            }
        });
        return index;
    }

    allowedPlaceholders = 'Allowed placeholders: {{name}}, {{email}}, {{feedback}}';

    doCollectAllCache() {
      this.isPublishing = true;
      this.publishInProcess = 'The cache is being generated';
      this.settingsService.collectAllCache().subscribe(async (resp) => {
        this.checkStatus();
      });
    }

    convertSettings() {
      this.isPublishing = true;
      this.publishInProcess = 'Settings Converting';
      this.settingsService.convertSettings().subscribe(async (resp) => {
        this.checkStatus();
      });
    }

    doPublish() {
        this.publishSettingsModalRef.hide();
        this.isPublishing = true;
        this.publishInProcess = 'Starting....';
        this.settingsService.publish(this.publishVersion, this.selectedLocale, this.productsToPublish).subscribe(async (resp) => {
            if ('version' in resp) {
              this.storage.putItem('isPublishing', 'true');
              this.isPublishing = true;
              this.toasterService.pop('success', 'publish in progress');
              this.checkStatus();
            };
            this.settingsService.loadPublishVersionsList().subscribe((data) => {
                this.publishVersionsList = data.versions;
                this.publishInProcess = data.publishInProcess;
                this.publishVersion = data.active;
            });
            this.closePublishDialog();
        },
        err => {
          console.log('Error', err);
          this.checkStatus();
        },
        () => console.log("the subscription is completed")
      );
    }

    openPublishDialog() {
      this.publishSettingsModalRef = this.modalService.show(this.publishSettingsFormTemplate);
    }

    closePublishDialog() {
      this.publishSettingsModalRef.hide();
      this.selectedLocale = [];
      this.productsToPublish = [];
      this.storage.removeItem('isPublishing');
      this.isPublishing = false;
    }

    checkStatus() {
      this.settingsService.loadPublishVersionsList().subscribe((data) => {
        this.publishInProcess = data.publishInProcess;
        this.isPublishing = this.publishInProcess !== "";
      });

    }

    closePublishSettingsDialog() {
      this.publishSettingsModalRef.hide();
    }

    RebuildCache () {
      this.isPublishing = true;
      this.publishInProcess = 'The cache is being generated';
      this.translationsService.rebuildCache().subscribe(() => {
        this.toasterService.pop('success', '', 'Done');
        this.checkStatus();
      });
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/settings/settings.component.ts